import React from 'react';
import { GridProps } from '@mui/material';
import { useIsNewSubway } from '../hooks/useIsNewSubway';
import { StyledSectionsOldWrapper, StyledSectionsWrapper } from './styles';
import { useWizardDrawer } from '../hooks/useWizardDrawer';
import { drawerWidth, drawerLeftSpace } from '../constants/wizard-drawer';

export const Sections = ({
  children,
  ...props
}: {
  children: React.ReactNode;
} & GridProps) => {
  const isNewSubway = useIsNewSubway();
  const { open } = useWizardDrawer();

  const SectionsWrapper = isNewSubway
    ? StyledSectionsWrapper
    : StyledSectionsOldWrapper;

  const additionalStyles = isNewSubway
    ? {
        marginLeft: !open
          ? `-${drawerWidth - drawerLeftSpace}px !important`
          : 0,
      }
    : {};

  return (
    <SectionsWrapper
      {...props}
      sx={{ ...props.sx, ...additionalStyles }}
      item
      xs={9}
    >
      {children}
    </SectionsWrapper>
  );
};
